import React from 'react';
import styles from 'assets/css/OverviewComponent.module.css';
import OverviewSubComponent from 'Components/Card/Components/OverviewSubComponent';
import CoursePartials from 'Components/Card/Partials/Partials.Course';
import OverviewProgressComponent, { defaultCanvasProps } from 'Components/Card/Components/OverviewProgressComponent';
import withSMARTGoalOnUpdateCardComponent from 'Components/Card/hoc/withSMARTGoalOnUpdateCardComponent';

function PAKOverviewCard(props) {
    const {
        ProgramTitle: titleText,
        EstimatedTimeToComplete: timeToComplete,
        Modules: modules,
        ProgressPercentage: percentageComplete,
        BodyStateCopy: bodyStateCopy
    } = props.data;


    return (
        <div className={styles["pak-wrapper"]}>
            <div className={styles["pak-header-wrapper"]}>
                <div className={styles["percentage-complete-wheel"]}>
                    <OverviewProgressComponent canvasCircleProps={defaultCanvasProps} canvasProps={{ width: "600", height: "600" }} modules={modules} percentageComplete={percentageComplete} />
                </div>
                <div className={styles["pak-header-content"]}>
                    <h3 className={styles.header}>{titleText}</h3>
                    <h4 className={styles.subtitle}>Estimated time to complete: {timeToComplete}</h4>
                    <CoursePartials.BodyCopy bodyStateCopy={bodyStateCopy} />
                </div>
            </div>
            <div className={styles["pak-body-wrapper"]}>
                {modules.map(component => <OverviewSubComponent {...component} />)}
            </div>
        </div>
    )
}

export default withSMARTGoalOnUpdateCardComponent(PAKOverviewCard);

/*
case ResultStatus.FAIL:
                return <IconSlashCircle fill="#E29907" />;
            case ResultStatus.DNA:
                return <IconDashCircle fill="#87A0AF" />;
            case ResultStatus.PASS:
            default:
                return <IconCheckmarkCircle fill="#4ABFAD" />;
*/

/*
OverviewCard: Card Props
- int? ProgressPercentage: Progress %
- string EstimatedTimeToComplete: Estimated Time to Complete
- string ProgramTitle: Program Name
- string ProgramDescription: Program/Card Description
- IEnumerable<OverviewCardModule> Modules


OverviewCardModule: Specific Module Props
- string DashboardTabKey
- CardLink ModuleLink
    - CardLinkText
    - CardLinkUri
    - CardLinkOrdinal
- DateTime? CompletionDate
- bool? Passed
- DateTime? VoucherExpiration
- string ModuleTitle
- OverviewModuleState ModuleState
    =>  - "Not_Started",
        - "Voucher_Expiring",
        - "Behind_Schedule",
        - "In_Progress",
        - "Complete"
- bool? Locked
- int PercentageComplete
- int Ordinal
*/
